import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DonutDisplay = _resolveComponent("DonutDisplay")!
  const _component_SaldoDisplay = _resolveComponent("SaldoDisplay")!
  const _component_PanelComponent = _resolveComponent("PanelComponent")!

  return (_openBlock(), _createBlock(_component_PanelComponent, {
    class: _normalizeClass(["statistics-tile", _ctx.type]),
    footer: false
  }, {
    default: _withCtx(() => [
      (_ctx.type === 'donut')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartsData, (chart) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: chart.name
              }, [
                _hoisted_1,
                _createVNode(_component_DonutDisplay, {
                  data: chart,
                  isLoading: _ctx.isLoading
                }, null, 8, ["data", "isLoading"])
              ], 64))
            }), 128)),
            _hoisted_2
          ], 64))
        : (_ctx.type === 'saldo')
          ? (_openBlock(), _createBlock(_component_SaldoDisplay, {
              key: 1,
              data: _ctx.saldoData
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}